import {
  MACHINE_LIGHT_LABEL,
  ORIGIN_LABEL,
  PRIORITY_LABEL,
  STATUS_LABEL,
  type MachineLight,
  type Priority,
  type TicketOrigin,
  type TicketStatus,
} from '@helpdesk/shared';
import { Badge, type BadgeTone } from './ui.tsx';

const statusTone: Record<TicketStatus, BadgeTone> = {
  new: 'red',
  accepted: 'info',
  in_progress: 'steel',
  waiting_part: 'warn',
  waiting_external: 'warn',
  waiting_reporter: 'warn',
  resolved: 'ok',
  closed: 'neutral',
  rejected: 'neutral',
};

export function StatusBadge({ status }: { status: TicketStatus }) {
  return <Badge tone={statusTone[status]}>{STATUS_LABEL[status]}</Badge>;
}

const priorityTone: Record<Priority, BadgeTone> = { p1: 'red', p2: 'error', p3: 'warn', p4: 'neutral' };

/** Priorität mit Wort und Kürzel – nie nur Farbe (Barrierefreiheit, Hallenlicht). */
export function PriorityBadge({ priority, short = false }: { priority: Priority; short?: boolean }) {
  return <Badge tone={priorityTone[priority]}>{short ? priority.toUpperCase() : PRIORITY_LABEL[priority]}</Badge>;
}

export function OriginBadge({ origin }: { origin: TicketOrigin }) {
  return <Badge tone="neutral">{ORIGIN_LABEL[origin]}</Badge>;
}

const lightColor: Record<MachineLight, string> = {
  ok: 'text-ok',
  impaired: 'text-warn',
  down: 'text-arnold-red',
  unreviewed: 'text-steel-500',
  decommissioned: 'text-steel-400',
};

/** Ampel mit Symbol und Text (F9) – Farbe allein reicht in der Halle nicht. */
export function MachineLightBadge({ light, large = false }: { light: MachineLight; large?: boolean }) {
  return (
    <span className={`ad-light ${lightColor[light]} ${large ? 'text-sm' : ''}`} title={MACHINE_LIGHT_LABEL[light]}>
      {MACHINE_LIGHT_LABEL[light]}
    </span>
  );
}
